import { render, staticRenderFns } from "./expensTable.vue?vue&type=template&id=6f81fa22&scoped=true&"
import script from "./expensTable.vue?vue&type=script&lang=js&"
export * from "./expensTable.vue?vue&type=script&lang=js&"
import style0 from "./expensTable.vue?vue&type=style&index=0&id=6f81fa22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f81fa22",
  null
  
)

export default component.exports